import {
  RELOAD_PAGE,
  UPDATE_CATEGORIES,
  UPDATE_PRODUCT_LIST,
  UPDATE_CURRENT_PRODUCT
} from "../_types";

const initial_state = {
  reload_page: false,
  current_product: { handle: null },
  product_list: [],
  categories: [],
};

const update_product_list = (state,payload=[]) => {

  if (payload.length===0) return {...state};

  return { ...state, product_list: [...payload] };

}

const update_category_list = (state,payload=[]) => {

  if (payload.length===0) return {...state};

  return { ...state, categories: [...payload] };

}

const trigger_page_reload = (state) => {

  const { reload_page } = state;

  return { ...state, reload_page: !reload_page };

}

const update_current_product = (state,payload={}) => {

  const { title } = payload;

  const current_title = state.current_product.title;

  if (title==='' || title===current_title) return {...state};

  return { ...state, current_product: {...payload} };

}

export default function(state = initial_state, { type, payload }) {

  switch (type) {

    case RELOAD_PAGE: return trigger_page_reload(state);

    case UPDATE_CATEGORIES: return update_category_list(state,payload);

    case UPDATE_PRODUCT_LIST: return update_product_list(state,payload);

    case UPDATE_CURRENT_PRODUCT: return update_current_product(state,payload);

    default: return state;

  }
}
